import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const resolveImageUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};

export const WHATSAPP_FALLBACK = "34638382033";

// Any legacy variants that must be overridden with the current number.
// Defensive guard in case the backend or a cached response still contains an old value.
const LEGACY_WHATSAPP_NUMBERS = ["34636382033", "636382033", "0034636382033"];

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const buildWhatsAppLink = (number, text) => {
  let phone = (number || WHATSAPP_FALLBACK).replace(/\D/g, "");
  // Override any legacy/stale value with the correct number.
  if (LEGACY_WHATSAPP_NUMBERS.includes(phone)) {
    phone = WHATSAPP_FALLBACK;
  }
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
};
